if (!customElements.get('product-recommendations')) {
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) {
					return;
				}

				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations');

						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;

							// Insert the wishlist checkboxes after loading the recommendations
							this.insertWishlistCheckboxes();
						}

						if (html.querySelector('.card')) {
							this.classList.add('product-recommendations-loaded');
						}
					})
					.catch(error => {
						console.error(error);
					});
			}

			new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
		}

		insertWishlistCheckboxes() {
			// Select all elements with the class 'zoomywishid' within the product recommendations
			const wishIdElements = this.querySelectorAll('.zoomywishid');

			// Iterate over each element to append the wishlist checkbox
			wishIdElements.forEach((element) => {
				const productId = element.getAttribute('data-product-id');

				// Create the wishlist checkbox HTML dynamically
				const wishlistCheckboxHTML = `
					<div class="zoomywishidheart" style="position:relative;">
						<input type="checkbox" data-id="${productId}" class="zoomycheck checkbox-${productId}" id="checkbox-${productId}">
						<label for="checkbox-${productId}">
							<p class="zooomywishmsg zooomywishmsg-${productId}">
								<i class="fa fa-heart-o" style="color: #000000;"></i>
							</p>
						</label>
					</div>
				`;

				// Insert the wishlist checkbox HTML inside the zoomywishid element
				element.insertAdjacentHTML('beforeend', wishlistCheckboxHTML);
			});
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);
}
